module.exports = __webpack_public_path__ + "img/375_news_main_img2.a0ca1753.png";